import axios from 'axios';

export const fetchTopOwners= (id: string) => {
  return axios.get(`/api/v1/assets/token/${id}/top_owners/`).then(({ data }) => data);
};
